export const removeMfilterEmptyKeys = (data, isFiltersKey) => {
    let shiftedObjectData = {};
    shiftedObjectData = Object.keys(data).reduce((resultData, currentProp) => {
        if (
            (currentProp === "start" ||
                currentProp === "end" ||
                currentProp === "start_year" ||
                currentProp === "end_year" ||
                currentProp === "update_fci" ||
                currentProp === "project_cost") &&
            data[currentProp] === ""
        ) {
            return resultData;
        } else if (currentProp === "filters" && (isFiltersKey === "filter" || isFiltersKey === "filter&topn")) {
            return { ...resultData, filters: data[currentProp] };
        } else if (currentProp === "top_n" && (isFiltersKey === "top_n" || isFiltersKey === "filter&topn")) {
            return { ...resultData, top_n: data[currentProp] };
        } else if (
            currentProp !== "start" &&
            currentProp !== "end" &&
            currentProp !== "start_year" &&
            currentProp !== "end_year" &&
            currentProp !== "update_fci" &&
            currentProp !== "project_cost" &&
            !data[currentProp]?.length
        ) {
            return resultData;
        }
        return { ...resultData, [currentProp]: data[currentProp] };
    }, {});
    return shiftedObjectData;
};
export const isFilterCleared = (prevState, bandName, entity) => {
    return {
        ...prevState,
        properties_text: {
            ...prevState.properties_text,
            [entity]: {
                ...prevState.properties_text[entity],
                [bandName]: {
                    ...prevState.properties_text[entity][bandName],
                    mfilter: Object.keys(prevState.properties_text[entity][bandName].mfilter).reduce((filteredData, key) => {
                        if (key === "client_ids" || key === "project_ids") {
                            filteredData[key] = prevState.properties_text[entity][bandName].mfilter[key];
                        }
                        return filteredData;
                    }, {}),
                    type: prevState.properties_text[entity][bandName]?.type
                        ? Object.keys(prevState.properties_text[entity][bandName].type).reduce((acc, key) => {
                              if (key?.startsWith("multi_recommendation")) {
                                  return {
                                      ...acc,
                                      [key]: {
                                          ...prevState.properties_text[entity][bandName].type[key],
                                          recommendations: [],
                                          number_of_recom: 0,
                                          config_filter: {},
                                          config_filter_names: {},
                                          mfilter: Object.keys(prevState.properties_text[entity][bandName].mfilter).reduce(
                                              (filteredData, keyValue) => {
                                                  if (keyValue === "client_ids" || keyValue === "project_ids") {
                                                      filteredData[keyValue] = prevState.properties_text[entity][bandName].mfilter[keyValue];
                                                  }
                                                  return filteredData;
                                              },
                                              {}
                                          )
                                      }
                                  };
                              } else if (["normal_recom", "recom_onepager", "asset-onepager"].some(e => key?.startsWith(e))) {
                                  let newConfigFilter = {
                                      number_of_recom: 0,
                                      recommendations: [],
                                      config_filter: {},
                                      config_filter_names: {},
                                      mfilter: Object.keys(prevState.properties_text[entity][bandName].mfilter).reduce((filteredData, keyValue) => {
                                          if (keyValue === "client_ids" || keyValue === "project_ids") {
                                              filteredData[keyValue] = prevState.properties_text[entity][bandName].mfilter[keyValue];
                                          }
                                          return filteredData;
                                      }, {})
                                  };
                                  if (key?.startsWith("asset-onepager")) {
                                      const { asset_ids, ...rest } = prevState.properties_text[entity][bandName].mfilter;

                                      newConfigFilter = { ...newConfigFilter, mfilter: { ...rest } };
                                  }
                                  return {
                                      ...acc,
                                      [key]: {
                                          ...prevState.properties_text[entity][bandName]?.type[key],
                                          band1: {
                                              ...(prevState.properties_text[entity][bandName]?.type[key]?.band1 || {}),
                                              ...newConfigFilter,
                                              mfilter: Object.keys(prevState.properties_text[entity][bandName].mfilter).reduce(
                                                  (filteredData, keyValue) => {
                                                      if (keyValue === "client_ids" || keyValue === "project_ids") {
                                                          filteredData[keyValue] = prevState.properties_text[entity][bandName].mfilter[keyValue];
                                                      }
                                                      return filteredData;
                                                  },
                                                  {}
                                              )
                                          }
                                      }
                                  };
                              } else if (key === "system" && prevState.properties_text[entity][bandName]?.type[key]?.normal_recom) {
                                  return {
                                      ...acc,
                                      [key]: {
                                          ...prevState.properties_text[entity][bandName]?.type[key],
                                          normal_recom: {
                                              ...prevState.properties_text[entity][bandName]?.type[key]?.normal_recom,
                                              band1: {
                                                  ...prevState.properties_text[entity][bandName]?.type[key]?.normal_recom?.band1,
                                                  mfilter: Object.keys(prevState.properties_text[entity][bandName].mfilter).reduce(
                                                      (filteredData, keyValue) => {
                                                          if (keyValue === "client_ids" || keyValue === "project_ids") {
                                                              filteredData[keyValue] = prevState.properties_text[entity][bandName].mfilter[keyValue];
                                                          }
                                                          return filteredData;
                                                      },
                                                      {}
                                                  )
                                              }
                                          }
                                      }
                                  };
                              }
                              return { ...acc, [key]: prevState.properties_text[entity][bandName]?.type[key] };
                          }, {})
                        : {},
                    filter_label: { Projects: prevState.properties_text[entity]?.[bandName]?.filter_label?.["Projects"] }
                }
            }
        }
    };
};
export const removeWildCardOrYear = (prevState, bandName, entity, isArray) => {
    return {
        ...prevState,
        properties_text: {
            ...prevState.properties_text,
            [entity]: {
                ...prevState.properties_text[entity],
                [bandName]: {
                    ...prevState.properties_text[entity][bandName],
                    mfilter:
                        prevState.properties_text[entity][bandName].mfilter &&
                        Object.keys(prevState.properties_text[entity][bandName].mfilter)?.reduce((acc, key) => {
                            if (isArray) {
                                const value = prevState.properties_text[entity][bandName]?.mfilter[key];
                                if (key === "project_ids" || key === "client_ids") {
                                    acc[key] = value;
                                }
                            }
                            return acc;
                        }, {}),
                    type: { ...prevState.properties_text[entity][bandName]?.type },
                    filter_label: {
                        ...removeMfilterEmptyKeys({
                            ...Object.fromEntries(
                                Object.entries(prevState?.properties_text?.[entity]?.[bandName]?.filter_label || {})
                                    .filter(([key, value]) => {
                                        const allowedKeys = ["Projects", "FCA Projects", "Client"];
                                        return allowedKeys.includes(key);
                                    })
                                    ?.map(([key, value]) => [key, Array.isArray(value) ? value : [value]])
                            )
                        })
                    }
                }
            }
        }
    };
};
export const getSelectedFilterValuesFormIds = (dropDownData = [], selectedIds = []) => {
    let filterDataIds = [];
    if (selectedIds.length) {
        selectedIds.forEach(data => {
            const found = dropDownData.find(e => e?.id === data);
            if (found) {
                filterDataIds.push(data);
            }
        });
    }
    return filterDataIds;
};
export const deepCompareObjects = (obj1, obj2) => {
    if (obj1 === obj2) return true;
    if (!obj1 || !obj2 || typeof obj1 !== "object" || typeof obj2 !== "object") return false;
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length || !keys1.every(key => keys2.includes(key))) return false;
    for (let key of keys1) {
        const value1 = obj1[key];
        const value2 = obj2[key];
        if (key === "ca_recommendation" || key === "ca_asset") {
            const parsedValue1 = typeof value1 === "string" ? JSON.parse(value1) : value1;
            if (!deepCompareObjects(parsedValue1, value2)) return false;
        } else if (typeof value1 === "object" && typeof value2 === "object") {
            if (!deepCompareObjects(value1, value2)) return false;
        } else if (value1 !== value2) return false;
    }
    return true;
};
